import { useId } from 'react';
import './FormSection.css';

/**
 * Seção reutilizável para agrupar campos relacionados e manter a mesma
 * hierarquia visual nos formulários dos diferentes módulos.
 */
const FormSection = ({
    title,
    description,
    icon,
    actions,
    children,
    compact = false,
    className = '',
    ...sectionProps
}) => {
    const generatedId = useId();
    const titleId = title ? `form-section-${generatedId.replace(/:/g, '')}` : undefined;
    const classes = [
        'form-section',
        compact ? 'form-section--compact' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <section className={classes} aria-labelledby={titleId} {...sectionProps}>
            {(title || description || icon || actions) && (
                <header className="form-section__header">
                    <div className="form-section__identity">
                        {icon && (
                            <span className="form-section__icon" aria-hidden="true">
                                <i className={icon} />
                            </span>
                        )}
                        <div className="form-section__heading">
                            {title && <h2 id={titleId} className="form-section__title">{title}</h2>}
                            {description && <p className="form-section__description">{description}</p>}
                        </div>
                    </div>
                    {actions && <div className="form-section__actions">{actions}</div>}
                </header>
            )}

            <div className="form-section__content">{children}</div>
        </section>
    );
};

export default FormSection;
